/**
 * 
 */
export default [
    {
        text    : "N° de documento",
        sortable: true,
        value   : "document_number",
    },
    {
        text    : "Sucursal",
        sortable: true,
        value   : ({ accounting_bank_card_branch_office }) => accounting_bank_card_branch_office.branch_office,
    },
    {
        text    : "Tipo",
        sortable: true,
        value   : ({ accounting_bank_card_movement_detail }) => accounting_bank_card_movement_detail.movement_detail,
    },
    {
        text    : "Deposito",
        sortable: true,
        value   : "deposit",
        format  : "currency"
    },
    {
        text    : "Emparejado",
        sortable: true,
        align   : 'center',
        value   : "matched",
        format  : "boolean"
    },
    {
        text    : "Creado el",
        sortable: true,
        value   : "created_at",
    },
    {
        text    : "Modificado el",
        sortable: true,
        value   : "updated_at",
    },
]
